import { useQueryState } from "@msuite/ui/libs/nuqs";
import type { Enums } from "@msuite/utils/types";
import { InvoicesStateSelect } from "./invoices-state-select";

export function InvoicesFilter() {
	/** State */
	const [invoicesStateQuery, setInvoicesStateQuery] = useQueryState("invoices-state", {
		defaultValue: "all",
		clearOnDefault: true,
	});

	/** Render */
	return (
		<div className="w-[200px]">
			<InvoicesStateSelect
				className="py-1 rounded-sm"
				defaultValue={invoicesStateQuery as Enums<"outgoingInvoiceState">}
				onChange={(value) => {
					setInvoicesStateQuery(value);
				}}
				withAll
			/>
		</div>
	);
}
